var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace44(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 86 85",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.414,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.686 75.948C24.131 75.947 9.091 60.971 9.091 42.499c0-18.473 15.04-33.449 33.595-33.449 18.553 0 33.594 14.976 33.594 33.449S61.239 75.948 42.686 75.948m0-75.948C19.112 0 0 19.027 0 42.5c0 23.471 19.112 42.499 42.686 42.499s42.685-19.028 42.685-42.5S66.259 0 42.685 0",
    fill: "#1f355e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.28 42.5c0 18.645-15.041 33.761-33.594 33.761-18.555 0-33.595-15.116-33.595-33.761 0-18.646 15.04-33.762 33.595-33.762 18.553 0 33.594 15.116 33.594 33.762",
    fill: "#ff6262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7 37.886c-.001 2.839-2.291 5.141-5.117 5.141-2.825 0-5.116-2.302-5.116-5.142 0-2.839 2.291-5.141 5.116-5.141 2.826 0 5.116 2.302 5.116 5.142M56.99 71.318a.822.822 0 01-.807-.751c-.316-3.916.926-7.91 3.423-10.945l.157-.188c.493-.594.957-1.157.965-1.731.011-.623-.571-1.156-1.114-1.383-.71-.308-1.578-.308-2.455-.288a60.322 60.322 0 00-26.368 6.853.806.806 0 01-1.094-.346.81.81 0 01.345-1.098 61.928 61.928 0 0127.077-7.04c1.036-.03 2.121-.02 3.127.416 1.055.445 2.111 1.522 2.101 2.906-.02 1.148-.749 2.037-1.342 2.749l-.148.178a13.766 13.766 0 00-3.057 9.779.818.818 0 01-.74.88c-.02.009-.04.009-.07.009M17.993 36.541a5.14 5.14 0 00-.195 1.343c0 2.844 2.287 5.144 5.115 5.144 2.828 0 5.116-2.3 5.116-5.144 0-.463-.078-.907-.196-1.343h-9.84z",
    fill: "#1f355e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace44);
export default __webpack_public_path__ + "static/media/face44.f4785a4109dacb47c3db272c89cbd54e.svg";
export { ForwardRef as ReactComponent };